export const appConfig = {
  appCode: 'ACE',
  appVersion: '3.11.0',
  appName: 'Adhesive Cartridge Estimator',
  logoUrl: 'assets/images/ace/ace-logo.svg',
  gaEventName: 'ACE_Events',
  downloadFileName: 'ACE-DATA',
  productThemeClasses: '-themeAnchors',
  navigationConfig: {
    showTutorial: true,
  },
}

export const initialState = {
  settings: {
    orientation: 'vertical',
    fontSize: '-densityCompact', // '-densityDefault',
    mediaClass: '-media-md',
    theme: '-themeLight', // (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ? '-themeDark' : '-themeLight',
    mobileNav: false,
  },
  calculation: {
    input: {
      subApp: '0',
    },
    status: {
      updatedCounter: -1,
      isLoading: false,
      isError: false,
      updateJobIndex: null,
      mobileViewOrderCounter: -1,
    },
    output: {},
  },
  status: {
    msgLevel: '',
    msgIconUrl: '',
    msgHeader: '',
    msgBody: '',
    noticeLevel: '',
    noticeIconUrl: '',
    noticeHeader: '',
    noticeBody: '',
  },
  feedback: {
    email: '',
    summary: '',
    description: '',
    attachments: [],
    showRecipients: false,
    recipients: '',
    validation: {
      email: 'Required',
      summary: 'Required',
      description: 'Required',
      attachments: '',
    },
  },
  calculationDoweling: {},
  calculationCI: {},
}

export const ADHESIVE_ANCHOR = {
  SET3G: 'SET-3G',
  SETXP: 'SET-XP',
  ET3G: 'ET-3G',
  ATXP: 'AT-XP',
  AT3G: 'AT-3G',
}

export const GAL_MODELS = {
  ET3G2KT: 'ET3G2KT',
  ET3G10KT: 'ET3G10KT',
  ET3G100KT: 'ET3G100KT'
} 